var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mx-2 mx-md-4 mx-3" }, [
    _c("div", { staticClass: "bg-white border-radius--light py-2" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Número de Registro: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.regStudentId) + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Número de Seguro Social: ")]
          ),
          _c(
            "div",
            {
              staticClass:
                "font-16 font-weight-normal color-black d-flex align-items-center"
            },
            [
              _c("div", { staticClass: "ssn-size" }, [
                _vm._v(_vm._s(_vm.ssn(_vm.value.studentSsn)))
              ]),
              _vm.canViewSSN
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex align-items-center",
                      on: {
                        click: function($event) {
                          _vm.showSSN = !_vm.showSSN
                        }
                      }
                    },
                    [
                      _c("em", {
                        staticClass: "cursor-pointer font-16",
                        class: {
                          "far fa-eye": !_vm.showSSN,
                          "far fa-eye-slash": _vm.showSSN
                        }
                      })
                    ]
                  )
                : _vm._e()
            ]
          )
        ]),
        _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Estatus de Estudiante: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.studentStatusName) + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Impedimento: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.impediment || "-") + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Región: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.regionName || "-") + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Distrito: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.districtName || "-") + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-6 col-sm col-12" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Escuela: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(
              " " +
                _vm._s(_vm.value.sieSchoolCode) +
                " - " +
                _vm._s(_vm.value.locationName) +
                " "
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-3 col-sm col-12" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Nombre Contacto: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.contactName) + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm col-12" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Parentesco Contacto: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.contactRelationName) + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm col-12" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Correo Electrónico Contacto: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.contactEmail) + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm col-12" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Teléfono Contacto: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.contactTelephone) + " ")
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "bg-gray p-1 m-0 ml-n4 mr-n4 pt-3" }),
    _c("div", { staticClass: "border-radius--light py-2 mt-4" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(1),
        _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Acompañante: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.transportationInfo.companionFlag == "1"
                    ? "Si"
                    : "No" || "-"
                ) +
                " "
            )
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Millaje: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.transportationInfo.mileage || "-") + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Partida-Lugar: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.transportationInfo.departure || "-") + " "),
            _c("em", { staticClass: "fas fa-arrow-alt-right text-green mr-1" }),
            _vm._v(" " + _vm._s(_vm.transportationInfo.location || "-") + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Alternativa de Ubicación: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(
              " " +
                _vm._s(_vm.transportationInfo.alternatePlacement || "-") +
                " "
            )
          ])
        ])
      ])
    ]),
    _vm.showTherapyInformationPanel
      ? _c("div", { staticClass: "bg-gray p-1 m-0 ml-n4 mr-n4 pt-3" })
      : _vm._e(),
    _vm.showTherapyInformationPanel
      ? _c("div", { staticClass: "border-radius--light py-2 mt-4" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(2),
            _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Proveedor: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [_vm._v(" " + _vm._s(_vm.thrpyInfo.providerName || "-") + " ")]
              )
            ]),
            _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Lugar de Servicio: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [
                  _vm._v(
                    " " + _vm._s(_vm.thrpyInfo.serviceLocation || "-") + " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Municipio: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("capitalize")(_vm.thrpyInfo.studentMunicipality)
                      ) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Modalidad: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("capitalize")(_vm.thrpyInfo.modalityName)) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-12 col-sm col-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Dirección Lugar de Servicio: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [
                  _vm._v(
                    " " + _vm._s(_vm.thrpyInfo.physicalAddress || "-") + " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Frecuencia: ")]
              ),
              _c(
                "div",
                { staticClass: "font-16 font-weight-normal color-black" },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.thrpyInfo.frequencyName || "-"))
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-italic color-black font-weight-bold" },
                    [_vm._v(" " + _vm._s(_vm.thrpyInfo.durationName) + " ")]
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-3 col-sm col-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Especialista: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.specialist(_vm.thrpyInfo.specialistAssign)) +
                      " "
                  )
                ]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-info-circle text-orange mr-1" }),
      _c("span", [_vm._v("Información Adicional")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-info-circle text-orange mr-1" }),
      _c("span", [_vm._v("Información de Transportación")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-info-circle text-orange mr-1" }),
      _c("span", [_vm._v("Información de Terapia")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }